/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weary_Whole_Scallop_SpurInputs */

const fr_weary_whole_scallop_spur = /** @type {(inputs: Weary_Whole_Scallop_SpurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour information, ton mot de passe doit faire 6 caractères minimum`)
};

/**

* @param {Weary_Whole_Scallop_SpurInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const weary_whole_scallop_spur = /** @type {((inputs?: Weary_Whole_Scallop_SpurInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weary_Whole_Scallop_SpurInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_weary_whole_scallop_spur(inputs)
});